import { BillingRecurringTypes } from "../responses/dashboard.license.response";

export class ReactivateRequestv2 {

    LicenseKey: string;
    Initials: string;
    CreditCardID: number;
    AdminID: number;
    NewProductID: number;
    IncludeYARD: boolean;
    BillingCycle: BillingRecurringTypes;
    assignToMember: boolean = true;
    keepAssigned: boolean = false;
	designerName: string = "";
	designerEmail: string = "";    
}